module.exports = __webpack_public_path__ + "img/128.2519935.jpg";